(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-ag-floating-personalization]';

  const updateCrystalTarget = (bar) => {
    if (!bar || bar.dataset.agFloatingCustomLink === 'true') return;
    const source = Array.from(document.querySelectorAll('[data-crystal-continue]'))
      .find((link) => link !== bar);
    if (source?.href) bar.href = source.href;
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((bar) => {
      if (bar.dataset.agFloatingInitialized === 'true') return;
      bar.dataset.agFloatingInitialized = 'true';

      if (bar.dataset.agFloatingMode === 'crystal') {
        updateCrystalTarget(bar);
        document.addEventListener('crystal:variant-change', () => {
          window.requestAnimationFrame(() => updateCrystalTarget(bar));
        });
      }

      if (bar.dataset.agFloatingMode === 'tumbler' && bar.dataset.agFloatingCustomLink !== 'true') {
        bar.addEventListener('click', (event) => {
          const entryButton = document.querySelector('[data-tumbler-entry-open]');
          if (!entryButton) return;
          event.preventDefault();
          entryButton.click();
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
